"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M3.933 0h9.404c.389 0 .705.316.705.705v14.8a.484.484 0 0 1-.484.484H2.663a.705.705 0 0 1-.705-.705V.712c0-.388.316-.704.703-.704h.266v.968h-.001v14.045h10.148V.968H3.933V0Zm2.82 4.065H4.987v2.707H6.78v-.445H5.581v-.723h.91v-.437h-.91V4.51h1.172v-.445Zm2.176 0H7.183v2.707h.598v-1.09h.894v-.441h-.894V4.51H8.93v-.445Zm.927.445H9.11v-.445h2.094v.445h-.75v2.262h-.598V4.51Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M5.76 0h14.325c.494 0 .896.402.896.897V23.44a.56.56 0 0 1-.56.56H3.826a.898.898 0 0 1-.897-.896V.907c0-.493.402-.894.894-.894h.24v1.12h-.014V22.88h15.813V1.119H5.76V0Zm9.023 6.69h-1.138v-.68h3.192v.68h-1.143v3.448h-.911V6.69Zm-4.724-.68H7.367v4.128h2.734v-.679H8.273V8.357H9.66V7.69H8.273v-1h1.786v-.68Zm3.315 0h-2.662v4.128h.91V8.476h1.364v-.673h-1.363V6.69h1.75v-.68Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M7.681 0H26.78c.659 0 1.195.536 1.195 1.196v30.058a.747.747 0 0 1-.746.746H5.102c-.66 0-1.196-.536-1.196-1.195V1.209c0-.657.535-1.192 1.192-1.192h.318V1.51h-.018v28.997h21.084V1.493h-18.8V0Zm12.03 8.92h-1.517v-.906h4.256v.905h-1.524v4.599H19.71V8.919Zm-6.299-.906h-3.59v5.503h3.646v-.905H11.03v-1.47h1.85v-.889h-1.85V8.92h2.382v-.906Zm4.42 0h-3.55v5.503h1.216v-2.215h1.818v-.898h-1.818V8.92h2.334v-.906Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M11.557.082H40.33c.89 0 1.614.725 1.614 1.615V46.98c0 .519-.42.938-.938.938H7.671c-.89 0-1.615-.725-1.615-1.615V1.717c0-.887.722-1.609 1.61-1.609h.268v1.875h-.003v44.06H40.07V1.957H11.557V.082ZM29.68 13.335h-2.284v-1.363h6.41v1.363H31.51v6.924h-1.83v-6.924Zm-9.49-1.363h-5.407v8.287h5.49v-1.363h-3.671v-2.212h2.786v-1.34H16.6v-2.009h3.588v-1.363Zm6.658 0h-5.346v8.287h1.83v-3.336h2.738v-1.351h-2.738v-2.237h3.516v-1.363Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M15.409.11h38.364c1.187 0 2.152.965 2.152 2.152V62.64a1.25 1.25 0 0 1-1.25 1.25H10.228a2.156 2.156 0 0 1-2.153-2.153V2.29c0-1.183.963-2.145 2.146-2.145h.358v2.5h-.004V61.39h42.85V2.61H15.409V.11Zm24.163 17.67h-3.044v-1.818h8.546v1.818h-3.061v9.232h-2.44V17.78ZM26.92 15.962h-7.208v11.05h7.32v-1.818h-4.896v-2.949h3.715V20.46h-3.715v-2.68h4.784v-1.818Zm8.878 0H28.67v11.05h2.44v-4.448h3.651v-1.802h-3.65V17.78h4.687v-1.818Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconDocumentEFT = function IconDocumentEFT(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Document EFT' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "DocumentEFT"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconDocumentEFT.sizes = [16, 24, 32, 48, 64];
IconDocumentEFT.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconDocumentEFT;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/account-experience/DocumentEFT.js
// module id = 1725
// module chunks = 0